import React from 'react';
import LegalLink from '../LegalLink';

export const MUST_BE_AUTHENTICATED = 'MUST_BE_AUTHENTICATED';

const LEGAL_BASE_URL = 'https://www.dignifi.com';
export const LEGAL_DISCLAIMER = (
  <>
    By clicking &quot;Create Account&quot;, you agree to the
    {' '}
    <LegalLink href={`${LEGAL_BASE_URL}/e-sign-disclosure`}>
      E-Sign Disclosure
    </LegalLink>
    ,
    {' '}
    <LegalLink href={`${LEGAL_BASE_URL}/privacy-policy`}>
      Privacy Policy
    </LegalLink>
    ,
    {' '}
    <LegalLink href={`${LEGAL_BASE_URL}/wp-content/uploads/2024/10/DigniFi_legalDoc-creditReportAuthorization.pdf`}>
      Credit Report Authorization
    </LegalLink>
    {' '}
    and
    {' '}
    <LegalLink href={`${LEGAL_BASE_URL}/terms-of-use`}>
      Terms of Use
    </LegalLink>
    . You authorize DigniFi and WebBank to obtain information about you,
    including your consumer report from a consumer reporting agency, for
    the purpose of assessing your creditworthiness.
  </>
);
